import React, { useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Grid, Button, MenuItem, TextField, Typography, Table,
  TableBody, TableCell, TableHead, TableRow, Divider,
  Box
} from "@mui/material";
import { DropDownList } from "./DropDownList";

const MESES = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

const getCuatrimestre = (mes) => {
  const idx = MESES.indexOf(mes);
  if (idx < 5) return "Primer cuatrimestre";
  if (idx < 9) return "Segundo cuatrimestre";
  return "Tercer cuatrimestre";
};

function UPSE2DetalleGeneral({
  open,
  onClose,
  onSubmit,
  subProducto,
  infoDetalle
}) {
  const [departamento, setDepartamento] = useState({ Nombre: "", Id: "" });
  const [municipio, setMunicipio] = useState({ Nombre: "", Id: "" });
  const [localidad, setLocalidad] = useState({ Nombre: "", Id: "" });

  const [mesSeleccionado, setMesSeleccionado] = useState("");
  const [cantidad, setCantidad] = useState("");
  const [observaciones, setObservaciones] = useState(infoDetalle?.observaciones || "");

  const [mesesDisponibles, setMesesDisponibles] = useState(
    MESES.filter(m => !(infoDetalle?.detalleCompleto || []).some(d => d.mes === m))
  );
  const [detalle, setDetalle] = useState(infoDetalle?.detalleCompleto || []);
  const [modoEdicion, setModoEdicion] = useState(null);

  const [mensajeError, setMensajeError] = useState("");

  useEffect(() => {
    if (infoDetalle && infoDetalle.detalleCompleto) {
      const usados = infoDetalle.detalleCompleto.map(d => d.mes);
      const disponibles = MESES.filter(m => !usados.includes(m));
      setMesesDisponibles(disponibles);
      setDetalle(infoDetalle.detalleCompleto || []);
      setObservaciones(infoDetalle.observaciones|| "");
      //setDepartamento(infoDetalle.departamento);
      //setMunicipio(infoDetalle.municipio);
      setLocalidad(infoDetalle.localidad);
    }
  }, [infoDetalle]);

  const agregarMes = () => {
    if (!mesSeleccionado || !cantidad) return;

    const nuevo = { mes: mesSeleccionado, cantidad: parseFloat(cantidad) };
    setDetalle([...detalle, nuevo]);
    setMesesDisponibles(mesesDisponibles.filter(m => m !== mesSeleccionado));
    setMesSeleccionado("");
    setCantidad("");
  };

  const eliminarMes = (index) => {
    const eliminado = detalle[index];
    setDetalle(detalle.filter((_, i) => i !== index));
    setMesesDisponibles([...mesesDisponibles, eliminado.mes].sort((a, b) => MESES.indexOf(a) - MESES.indexOf(b)));
  };

  const editarCantidad = (index, nuevaCantidad) => {
    const nuevos = [...detalle];
    nuevos[index].cantidad = parseFloat(nuevaCantidad);
    setDetalle(nuevos);
  };

  const editarMes = (index, nuevoMes) => {
    const anteriores = [...detalle];
    const anteriorMes = anteriores[index].mes;

    anteriores[index].mes = nuevoMes;
    setDetalle(anteriores);

    setMesesDisponibles(prev =>
      [...prev.filter(m => m !== nuevoMes), anteriorMes].sort((a, b) => MESES.indexOf(a) - MESES.indexOf(b))
    );
  };

  const calcularCuatrimestres = () => {
    const resumen = {"Primer cuatrimestre": 0, "Segundo cuatrimestre": 0, "Tercer cuatrimestre": 0 };
      detalle.forEach(({ mes, cantidad }) => {
      resumen[getCuatrimestre(mes)] += cantidad;
    });
    return resumen;
  };

  const calcularTotal = (arreglo) => {
    const suma = arreglo.reduce((acumulador, objetoActual) => acumulador + objetoActual.cantidad, 0);
    return suma;
  }

  const registrar = () => {
    // validaciones
    if(localidad.Id ===""){
      setMensajeError("* Ingrese la localidad designada")
      return;
    }
    if(calcularTotal(detalle) === 0){
      setMensajeError("* Debe ingresar al menos un detalle de mes")
      return;
    }
    setMensajeError("");
    // rellenar con ceros los departamentos que no fueron ingresados
    const mesesRegistrados = detalle.map(item => item.mes);
    const mesesFaltantes = mesesDisponibles.filter(
      mes => !mesesRegistrados.includes(mes)
    );
    const mesesConCero = mesesFaltantes.map(mes => ({
      mes, cantidad: 0
    }))
    const detalleCompleto = [...detalle, ...mesesConCero];
    const payload = {
      //departamento,
      //municipio,
      localidad,
      detalleCompleto,
      observaciones,
      total: calcularTotal(detalleCompleto),
      subProducto
    };
    //console.log("Datos enviados:", payload);
    setDetalle([]);
    setMesesDisponibles(MESES);
    setObservaciones("");
    setMensajeError("");
    onSubmit(payload);
    onClose();
  };

  const cancelar = () => {
    //console.log(infoDetalle)
    setDetalle([]);
    setMesesDisponibles(MESES);
    setObservaciones("");
    setMensajeError("");
    onClose();
  }

  const cuatrimestres = calcularCuatrimestres();

  return (
    <Dialog open={open} onClose={cancelar} maxWidth="md" fullWidth>
      <DialogTitle>Detalle de productos </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          
          <Grid item xs={6} sm={4}>
            <p>Departamento</p>
            <DropDownList
              required
              title="Departamento"
              endpoint={"/localidad/listActiveDepartamento/"}
              selectedItem={departamento}
              setSelectedItem={setDepartamento}
              selected={infoDetalle?.departamento}
            />
          </Grid>

          <Grid item xs={6} sm={4}>
            <p>Municipio</p>
            <DropDownList
              required
              title="Municipio"
              endpoint={"/localidad/listActiveMunicipio/"+departamento.Id}
              selectedItem={municipio}
              setSelectedItem={setMunicipio}
              selected={infoDetalle?.municipio}
              withParams={true}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <p>Centro de costo</p>
            <DropDownList
              required
              title="Localidad o centro de costo"
              endpoint={"/localidad/listLocalidades"}
              selectedItem={localidad}
              setSelectedItem={setLocalidad}
              selected={infoDetalle?.localidad}
            />
          </Grid>

          {/* Segunda fila: mes, cantidad, botón */}
          <Grid item xs={12} sm={4}>
            <TextField
              select
              label="Mes"
              fullWidth
              value={mesSeleccionado}
              onChange={(e) => setMesSeleccionado(e.target.value)}
            >
              {mesesDisponibles.map((mes) => (
                <MenuItem key={mes} value={mes}>{mes}</MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Cantidad"
              type="number"
              fullWidth
              value={cantidad}
              onChange={(e) => setCantidad(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}> 
            <Button fullWidth variant="contained" onClick={agregarMes} style={{marginTop: 10}}>Agregar</Button> 
          </Grid>


          {/* Tabla editable */}
          <Grid item xs={12} sm={12}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Mes</TableCell>
                  <TableCell>Cantidad</TableCell>
                  <TableCell>Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {detalle.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      {modoEdicion === index ? (
                        <TextField
                          select
                          value={item.mes}
                          onChange={(e) => editarMes(index, e.target.value)}
                        >
                          {[item.mes, ...mesesDisponibles].map(mes => (
                            <MenuItem key={mes} value={mes}>{mes}</MenuItem>
                          ))}
                        </TextField>
                      ) : item.mes}
                    </TableCell>
                    <TableCell>
                      {modoEdicion === index ? (
                        <TextField
                          type="number"
                          value={item.cantidad}
                          onChange={(e) => editarCantidad(index, e.target.value)}
                        />
                      ) : `${item.cantidad}`}
                    </TableCell>
                    <TableCell>
                      {modoEdicion === index ? (
                        <Button onClick={() => setModoEdicion(null)}>Guardar</Button>
                      ) : (
                        <>
                          <Button onClick={() => setModoEdicion(index)}>Editar</Button>
                          <Button color="error" onClick={() => eliminarMes(index)}>Eliminar</Button>
                        </>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid>

          {/* Subtotales */}
          <Grid item xs={12} sm={8} />
          <Grid item xs={12} sm={4}>
            <Divider sx={{ my: 2 }} />
            {Object.entries(cuatrimestres).map(([cuatri, total]) => (
              <Typography key={cuatri}>{cuatri}: {total}</Typography>
            ))}
            <Typography key={"tot"}>Total: {calcularTotal(detalle)}</Typography>
          </Grid>

          {/* Observaciones */}
          <Grid item xs={12}>
            <TextField
              label="Observaciones"
              fullWidth
              multiline
              rows={3}
              value={observaciones}
              onChange={(e) => setObservaciones(e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Typography color={'error'} marginRight={2}>{mensajeError}</Typography>
        <Button onClick={cancelar}>Cancelar</Button>
        <Button onClick={registrar} variant="contained" color="primary">Registrar</Button>
      </DialogActions>
    </Dialog>
  );
}

export { UPSE2DetalleGeneral };